import ModalGlobal from "../modalGlobalTopbar/ModalGlobalTopbar";
import { useEffect, useRef, useState } from "react";
import style from "./ModalUsuarioInfo.module.css";
import { Link } from "react-router-dom";
import { RiLogoutBoxRFill } from "react-icons/ri";
import Cookies from "js-cookie";

function ModalUsuarioInfo({ mostrar, aoFechar, botaoRef }) {
  const modalRef = useRef(null);
  const [posicao, setPosicao] = useState({ top: 0, left: 0 });

  // Função para calcular a posição do modal
  const calcularPosicao = () => {
    if (botaoRef.current) {
      const rect = botaoRef.current.getBoundingClientRect();
      const modalWidth = 205; // Largura do modal
      const windowWidth = window.innerWidth;

      // Ajusta a posição para evitar que o modal ultrapasse a borda direita da janela
      const left = Math.min(
        rect.right - modalWidth,
        windowWidth - modalWidth - 10
      ); // 10px de margem de segurança

      setPosicao({
        top: rect.bottom + 5, // 5px de margem abaixo do botão
        left: left - 2,
      });
    }
  };

  useEffect(() => {
    if (mostrar) {
      calcularPosicao(); // Atualiza a posição ao abrir

      // Atualiza a posição ao redimensionar a janela
      window.addEventListener("resize", calcularPosicao);
    }

    return () => {
      window.removeEventListener("resize", calcularPosicao);
    };
  }, [mostrar]); // Recalcula sempre que o modal for mostrado

  function Deslogar() {
   
    Cookies.remove("token");


    Cookies.remove("token", { domain: process.env.REACT_APP_DOMINIO, path: "/" });

    const loginUrl = process.env.REACT_APP_LOGIN_URL || "/login";

    window.location.href = loginUrl;
  }


  return (
    <ModalGlobal mostrar={mostrar} aoFechar={aoFechar}>
      <div
        ref={modalRef}
        className={style.container_modal}
        style={{ top: `${posicao.top}px`, left: `${posicao.left}px` }}
      >
        <Link onClick={Deslogar} className={style.topbar_item}>
          <RiLogoutBoxRFill />
          <h3 className={style.texto_link}>Sair</h3>
        </Link>
      </div>
    </ModalGlobal>
  );
}

export default ModalUsuarioInfo;
